import BehaviorExpressionParser from './parsers/expression/behavior_expression_parser';
import BehaviorsEventsSubscriber from './parsers/event/behaviors_events_subscriber';
import BehaviorActionsExecutor from './parsers/action/behavior_actions_executor';
import FlashMessagesTypes from '../flash_message/constants/flash_messages_types';
import { FlashMessageAPI } from 'lecom-api';

import { FormAPI, ProcessAPI } from 'lecom-api';
import { getCookie } from '../utils/cookie_utils';
import { actionsMapped } from './utils/behaviors_translate';
import { isOperationGrid } from './constants/behavior_action_types';
import { getFieldAPI } from './utils/form_element_api_builder';

export const init = ({ formStoreId }) => {
	const formAPI = new FormAPI({ storeId: formStoreId });

	try {
		BehaviorsEventsSubscriber.subscribe(formAPI, executeBehaviorActionsOnCondition);
	}
	catch(err) {
		catchErrorBehaviorEngine(err);
	}
	return Promise.resolve();
};

const buildActionValue = (actionTranslate, currentAction) => {
	let objAction = {
		value: currentAction.action_value || actionTranslate.value,
		type: actionTranslate.valueType,
		formActionName: actionTranslate.actionType === 'FIELD_REQUIRED' || actionTranslate.actionType === 'FIELD_OPTIONAL' ? currentAction.submit_action : undefined
	};

	if (currentAction.field_id_value) {
		objAction.type = "FIELD";
		objAction.fieldId = currentAction.field_id_value;
		objAction.value = null;
	}

	if (currentAction.element_value === "SCRIPT") {
		objAction.type = "SCRIPT";
	}

	if (isOperationGrid(currentAction.element_value)) {
		objAction.type = "OPERATION_GRID";
		objAction.value = currentAction.element_value.split("_")[1];
		objAction.gridId = currentAction.grid_alias;
		objAction.gridFieldId = currentAction.grid_field_id;
	}

	return objAction;
}

const buildCondition = (curC) => {
	let objCondition = {
		leftOperand: { fieldId: curC.field_id || curC.grid_alias, property: "value", type: "FIELD" },
		operator: curC.operator,
		rightOperand: { type: "VALUE", value: curC.condition_value },
		type: 'EXPRESSION'
	};

	if (curC.field_id_value) {
		objCondition.rightOperand = {
			fieldId: curC.field_id_value,
			property: "value",
			type: "FIELD"
		};
	}

	return objCondition;
}

const executeBehaviorActionsOnCondition = (formAPI, behavior, currentEvent) => {
	const { conditions_group, actions } = behavior;

	const conditionsGroupEnabled = conditions_group.reduce((accCg, curCg) => {
		const conditions = curCg.conditions.filter(c => c.enabled);

		if (!conditions.length) {
			return accCg;
		}

		return [...accCg, { ...curCg, conditions }];
	}, []);

	const resultExpression = conditionsGroupEnabled.reduce((accCg, curCg, iCg) => {
		const expression = curCg.conditions.reduce((accC, curC, iC) => {
			const result = !!BehaviorExpressionParser.parse(formAPI, buildCondition(curC));

			if (iC === 0) {
				return `(${result}${iC === curCg.conditions.length - 1 ? ")" : ""}`;
			}

			return `${accC} ${curC.conditional === "AND" ? "&&" : "||"} ${result}${iC === curCg.conditions.length - 1 ? ")" : ""}`;
		}, "");

		if (iCg === 0) {
			return `${curCg.negate ? '!' : ''}${expression}`;
		}

		return `${accCg} ${curCg.conditional === "AND" ? "&&" : "||"} ${curCg.negate ? '!' : ''}${expression}`;
	}, "");

	const actionsFormatted = actions.map(currentAction => {
		const isRefreshButtonAction = currentAction.action_type === 'ACTION_EXECUTE' && currentAction.field_id;
		const isAction = currentAction.action_alias && currentAction.field_id && formAPI.actions(currentAction.action_alias);
		let actionTranslate = actionsMapped.find(m => m.actionType === currentAction.action_type);
		let action_alias = currentAction.action_alias;

		if (isRefreshButtonAction) {
			let field = formAPI.fields(currentAction.field_id);

			if (!field) {
				field = getFieldAPI(formAPI, { fieldId: currentAction.field_id });
			}

			action_alias = field ? field.id : "";
		}

		if (isAction) {
			const mapActionType = {
				FIELD_SET_LABEL: "ACTION_SET_LABEL",
				FIELD_SET_HIDDEN: "ACTION_HIDDEN",
				FIELD_SET_VISIBLE: "ACTION_SHOW",
				ACTION_SET_LABEL: "ACTION_SET_LABEL",
				ACTION_HIDDEN: "ACTION_HIDDEN",
				ACTION_SHOW: "ACTION_SHOW"
			};

			actionTranslate = actionsMapped.find(m => m.actionType === mapActionType[currentAction.action_type])
		}

		return {
			...currentAction,
			element: actionTranslate.element,
			property: actionTranslate.property,
			type: actionTranslate.type,
			value: actionTranslate.actionType !== 'ACTION_EXECUTE' ? buildActionValue(actionTranslate, currentAction) : undefined,
			fieldId: currentAction.field_id,
			gridId: currentAction.grid_alias,
			groupId: currentAction.group_id,
			actionId: action_alias
		};
	});

	try {
		if (conditionsGroupEnabled.length === 0 || !!new Function(`return ${resultExpression}`)()) {
			BehaviorActionsExecutor.execute(formAPI, behavior, currentEvent, actionsFormatted.filter(a => a.conditional === "IF" && a.enabled));
		} else {
			BehaviorActionsExecutor.execute(formAPI, behavior, currentEvent, actionsFormatted.filter(a => a.conditional === "ELSE" && a.enabled));
		}
	}
	catch(err) {
		catchErrorBehaviorEngine( err);
	}
};

function catchErrorBehaviorEngine(err) {
	const message = Realize.i18n.t(err.message) || err.message;
	if (ProcessAPI.currentProcess().isTestMode()) {
		FlashMessageAPI.flash().addMessage({
			type: FlashMessagesTypes.ERROR,
			message: Realize.i18n.t(err.message) || err.message
		});
	} else {
		console.warn(message);
	}
}

export default {
	init,
};
